<template>
  <div>
    <!-- ALERT MESSAGE STARTS -->
    <transition name="fade">
        <div class="alert alertmessage" :class="{'alert-warning' : !alert.isSuccess, 'alert-success' : alert.isSuccess}" v-if="alert.showAlert">
          <strong>{{ alert.isSuccess ? 'Success' : 'Error'}}!</strong>

          <br><br>
          <p v-for="message in alert.alertMessage">♢ {{ message }}</p>
        </div>
    </transition>
    <!-- ALERT MESSAGE ENDS -->

    <component :is="currentComponent">
    </component>
  </div>
</template>

<script>
import PageOptions from '@/Options/PageOptions.js';
import DaihatsuDashboard from './Daihatsu/MainDashboard';
    
export default {
    metaInfo: {
      title: 'BI Dashboard',
      titleTemplate: '%s - QTrust',
      htmlAttrs: {
        lang: 'en',
        amp: true
      }
    },
    components : {
        DaihatsuDashboard
    },
    data(){
        return{
            pageOptions : PageOptions,
            currentComponent : '',
            alert : this.$store.getters.getAlertStatus,
            alertDuration : 5000,//in ms
        }
    },
    created(){
        this.pageOptions.pageEmpty = false;
        this.currentComponent = this.$store.state.company + "Dashboard";

        this.$apm.setUserContext({
          id: user.user_id,
          username: user.username
        });
        
        this.$apm.setCustomContext({
          access_time : new moment().format('Y-MM-DD HH:mm:ss'),
          route : this.$route.path
        })
    },
    mounted(){
      this.checkAlert();
    },
    watch : {
      '$store.getters.getAlertStatus' : function () {
        this.alert = this.$store.getters.getAlertStatus;
        this.checkAlert();
      }
    },
    beforeRouteLeave (to, from, next) {
      PageOptions.pageEmpty = true;
      next();
    },
    methods:{
      checkAlert(){
        setTimeout(()=>{
          if(this.alert.showAlert) this.$store.dispatch('setShowAlert', false);
        }, this.alertDuration);
      }
    }
}
</script>

<style>
  .align-middle{
    display: flex;
    flex-direction: column;
    justify-content: center; 
  }

  .outerBox{
    padding: 0 20px;
  }
  .innerBox{
    padding: 1.5rem;
    border:1px solid #EEEEEE;
    border-radius:5px;
    background-color: white;
    box-shadow: 2px 2px 5px #E0E0E0;
  }

	/* FLATPICKR CUSTOM CSS START */
	input[readonly].flatpickr-input{
		background-color:#fff !important;
		height:43px;
	}
	/* FLATPICKR CUSTOM CSS END */

  /* MODAL STARTS */
  .modal-mask {
    position: fixed;
    z-index: 1020;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .5);
    display: table;
    transition: opacity .3s ease;
  }

  .modal-wrapper {
    display: table-cell;
    vertical-align: middle;
  }

  .modal-container {
    width: 100%;
    margin: 0px auto;
    padding: 20px 30px;
    background-color: #fff;
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
    transition: all .3s ease;
    font-family: Helvetica, Arial, sans-serif;
  }

  .modal-header h3 {
    margin-top: 0;
    color: #42b983;
  }

  .modal-body {
    margin: 20px 0;
  }

  .modal-default-button {
    float: right;
  }

  /*
  * The following styles are auto-applied to elements with
  * transition="modal" when their visibility is toggled
  * by Vue.js.
  *
  * You can easily play with the modal transition by editing
  * these styles.
  */

  .modal-enter {
    opacity: 0;
  }

  .modal-leave-active {
    opacity: 0;
  }

  .modal-enter .modal-container,
  .modal-leave-active .modal-container {
    -webkit-transform: scale(1.1);
    transform: scale(1.1);
  }

  /* MODAL STARTS */
  .modal-body{
    margin:0;
    max-height: 80vh;
    overflow-x : auto;
    overflow-y : auto;
  }

  .modal-body .moduleLine{
    margin-bottom: 0vh;
  }

  .modal-body .moduleLine a{
    text-decoration: none;
  }

  .modal-body .moduleLine .moduleBox:hover{
    background-color: #E0E0E0;
    transition: background-color 0.7s ease;
    color: #212121;
    transition: color 0.7s ease;
  }

  .modal-body .moduleLine .moduleBox{
    border:1px solid #BDBDBD;
    border-radius: 20px;
    padding: 20px 0;
    color:black;
    margin-bottom: 3vh;
  }

  .modal-body .moduleLine .moduleBox i{
    font-size:5vh;
  }

  h3.modalHeadline{
    margin:0 0 20px 0;
    font-weight: bold;
    text-align : center;
  }
  /* MODAL ENDS */

  /* ALERT MESSAGE STARTS */
  .alertmessage {
      position: fixed;
      top: 10%;
      left: 50%;
      transform: translate(-50%, 0);
      z-index:9999;
      width: 300px;
      text-align: center;
  }
  .alertmessage strong{
      font-size: 150%
  }
  .fade-enter-active, .fade-leave-active {
      transition: opacity .5s;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
      opacity: 0;
  }
  /* ALERT MESSAGE ENDS */

</style>